import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { TextInputDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface ShortcutsColorSettingDefinition extends TextInputDefinition {
    key: 'SHORTCUTS_COLOR';
}

const definition: ShortcutsColorSettingDefinition = {
    key: 'SHORTCUTS_COLOR',
    label: 'Shortcuts color',
    type: 'TextInput',
    value: '',
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const ShortcutsColorSettingDefinition = define({
    key: 'SHORTCUTS_COLOR',
    label: 'shortcuts color',
    definition,
    fromSetting: (settings, _, view) =>
        specSettingsInterface.extractValue(settings.shortcutsColor) || (view ? undefined : ''),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.shortcutsColor)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(settings.shortcutsColor),
});
